import * as svg from "../../../assets/block-checkin-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const BlockCheckinIcon = iconBuilder(svg, "BlockCheckinIcon", "0 0 20 20");
